import { all, call, put } from 'redux-saga/effects';
import {
  fetchHistoricDay,
  fetchHistoricWeek,
  fetchHistoricMonth,
  getRangeGraph,
} from '../../../services/api';
import { notifyError } from '../../../utils';

const fetchByPeriod = {
  daily: fetchHistoricDay,
  weekly: fetchHistoricWeek,
  monthly: fetchHistoricMonth,
};

// Sub-saga: busca os dados historicos e dispatcha assim que chegam (sem
// esperar pelos ranges). E aqui que o grafico realmente comeca a pintar.
function* fetchHistoricSeries(variable, period, thing, thingId) {
  const fetcher = fetchByPeriod[period];
  if (!fetcher) return;
  try {
    const historic = yield call(fetcher, variable, thing);
    yield put({
      type: 'HISTORIC/SET_VARIABLE',
      variable,
      period,
      thingId,
      data: (historic && historic.data) || [],
    });
    if (!historic || !historic.data) notifyError('erro ao buscar o histórico');
  } catch (e) {
    yield put({
      type: 'HISTORIC/SET_VARIABLE',
      variable,
      period,
      thingId,
      data: [],
    });
    notifyError('erro ao buscar o histórico');
  }
}

// Sub-saga: busca os ranges (referencias de warning/erro). Independente
// do historico — ranges so afetam ReferenceLines, nao a serie em si.
function* fetchRanges(variable, period, thingId, variablesId) {
  try {
    const ranges = yield call(getRangeGraph, thingId, variablesId);
    if (ranges && ranges.data) {
      yield put({
        type: 'HISTORIC/SET_VARIABLE',
        variable,
        period,
        thingId,
        ranges: ranges.data,
      });
    }
  } catch (e) {
    // Falha silenciosa: ausencia de ranges nao impede o grafico.
  }
}

// Antes: sequencial. Buscava historico → esperava terminar → buscava ranges
// → dispatchava ambos juntos. Operador via o grafico so depois das 2
// requests completarem.
// Agora: 2 sub-sagas em paralelo. Cada uma dispatcha assim que sua request
// resolve. Grafico aparece no max(t_historic, t_ranges) → quase sempre no
// t_historic isolado (ranges sao menores).
export function* fetchHistoricData({
  variable,
  period,
  thing,
  thingId,
  variablesId,
}) {
  if (!variablesId) {
    notifyError('O usuário não possui variáveis favoritas');
    return;
  }
  yield all([
    call(fetchHistoricSeries, variable, period, thing, thingId),
    call(fetchRanges, variable, period, thingId, variablesId),
  ]);
}
